import React, { useEffect, useState } from "react";
import { Detector } from "react-detect-offline";
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Box, Typography, Grid } from '@mui/material';

const CheckConnection = (props) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Detector
      render={({ online }) =>
        online ? (
          props.children
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: '100vh', // Takes up the full viewport height
              p: 2, // Add some padding
            }}
          >
            <Grid container spacing={2} justifyContent="center" alignItems="center" direction="column">
              <Grid item xs={12}>
                <WifiOffIcon
                  sx={{
                    fontSize: {
                      xs: 80,  // On extra-small screens and up
                      sm: 100, // On small screens and up
                    },
                    color: '#1570EF',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 1 }}>
                  No Connection
                </Typography>
                <Typography variant="subtitle1" component="h4">
                  Please check your internet connection
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )
      }
    />
  );
};

export default CheckConnection;